import { RouteWithGates } from '../api/routes';
import { DuplicateAnalysis } from '../types/Gate';

/**
 * How the rest of the Route Management page keeps up with its list: which
 * gates the list is showing, so the map can fade the others, and what a
 * selection amounts to once a filter hides part of it.
 */

/** Every gate on these routes. */
export function gateIdsOfRoutes(routes: RouteWithGates[]): Set<string> {
  return new Set(routes.flatMap((route) => (route.gates ?? []).map((gate) => gate.id)));
}

/** Every gate in a duplicate group: what the Duplicates view lists. */
export function gateIdsOfDuplicateGroups(analysis: DuplicateAnalysis | null | undefined): Set<string> {
  return new Set((analysis?.duplicate_groups ?? []).flatMap((group) => group.gates.map((gate) => gate.id)));
}

/** How many of these routes are ticked. */
export function countSelected(routes: RouteWithGates[], selectedIds: Set<string>): number {
  return routes.filter((route) => selectedIds.has(route.id)).length;
}

/**
 * The selection summary in the action bar. A selection survives a change of
 * filter, so the summary says when the filter is hiding part of it: Merge
 * Selected and Delete Selected act on the hidden routes too.
 */
export function describeSelection(selectedCount: number, shownCount: number): string {
  const hidden = selectedCount - shownCount;
  const base = `${selectedCount} selected`;
  return hidden > 0 ? `${base}, ${hidden} not shown by this filter` : base;
}
